// extracted by mini-css-extract-plugin
export default {"infoCard":"styles-module__infoCard__dc6d60112cf1a2e26268","heading":"styles-module__heading__c2060941168a54c7e6af","description":"styles-module__description__c26c8530de1c0e263817"};